module.exports = __webpack_public_path__ + "static/img/14000506.bb4e4b0f.png";